export const startLogoutRequest = () => ({
    type:"START_LOGOUT_REQUEST"
})

export const startLogoutSuccess = () => ({
    type:"START_LOGOUT_SUCCESS"

})
